import React from 'react';
import PropTypes from 'prop-types';
import PredictiveSearch from '../../predictive-search/js/PredictiveSearch';
import flagSuggestionTemplate from '../html/flag-suggestion.hbs';
import playerSuggestionTemplate from '../html/player-suggestion.hbs';
import { redirectTo } from '../../../general/js/utils';

const SUGGESTION_TYPE_PLAYER = '2';
const SUGGESTION_TYPE_FLAG = '1';

export default class QualifiedPlayersPredictiveSearch extends React.PureComponent {
    constructor(props) {
        super(props);

        this.onClear = this.onClear.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.renderSuggestion = this.renderSuggestion.bind(this);
    }

    onClear() {
        this.props.onFiltersChange(getPredictiveSearchDefaultFilters());
    }

    onChange(e) {
        // Change filters without applying
        this.props.onFiltersChange({
            ...getPredictiveSearchDefaultFilters(),
            term: e.target.value,
        }, false);
    }

    onSelect(value, type, suggestionInfo) {
        switch (type) {
            case SUGGESTION_TYPE_PLAYER:
                redirectTo(suggestionInfo.playerURL);
                break;
            default:
                this.props.onFiltersChange({
                    term: value,
                    searchType: type,
                    countryId: suggestionInfo.countryId || ''
                });
                break;
        }
    }

    onSubmit() {
        // Apply current filters
        this.props.onFiltersChange({});
    }

    renderSuggestion(text, type, info, highlightedText) {
        let result;
        switch (type) {
            case SUGGESTION_TYPE_FLAG:
                result = flagSuggestionTemplate({ text, highlightedText, info });
                break;
            case SUGGESTION_TYPE_PLAYER:
                result = playerSuggestionTemplate({ text, highlightedText, info });
                break;
            default:
                result = text;
        }

        return result;
    }

    render() {
        let { filters, ...passProps } = this.props; // eslint-disable-line
        const { term, type } = filters;
        return (
            <PredictiveSearch {...passProps}
                query={term}
                queryType={type}
                isSubmitted={this.props.isFiltersApplied}
                onClear={this.onClear}
                onChange={this.onChange}
                onSelect={this.onSelect}
                onSubmit={this.onSubmit}
                renderSuggestion={this.renderSuggestion}/>
        );
    }
}

QualifiedPlayersPredictiveSearch.propTypes = {
    onFiltersChange: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    isFiltersApplied: PropTypes.bool.isRequired,
};

export function getPredictiveSearchDefaultFilters() {
    return {
        term: '',
        searchType: '',
        countryId: ''
    };
}
